import { DateTime } from 'luxon';

export const formatSendTime = (sendTime?: string | number): string => {
	if (!sendTime) return '';

	const dateTime =
		typeof sendTime === 'number' ? DateTime.fromSeconds(sendTime) : DateTime.fromISO(sendTime);

	if (!dateTime.isValid) return '';

	if (dateTime.hasSame(DateTime.now(), 'day')) {
		return `${dateTime.toLocaleString(DateTime.TIME_SIMPLE)}`;
	}

	return dateTime.toLocaleString(DateTime.DATETIME_MED);
};
